import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import InputWithOptions from '../InputWithOptions';
import SearchIcon from 'wix-ui-icons-common/Search';
import { StringUtils } from '../utils/StringUtils';
import styles from './Search.scss';
import Input from '../Input/Input'; // because lodash debounce is not compatible with jest timeout mocks

function debounce(fn, wait) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(context, args);
    }, wait);
  };
}
/**
 * Search component with suggestions based on input value listed in dropdown
 */


var Search = /*#__PURE__*/function (_Component) {
  _inherits(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_makeOnChange", function () {
      return _this.props.debounceMs > 0 ? debounce(_this.props.onChange, _this.props.debounceMs) : _this.props.onChange;
    });

    _defineProperty(_assertThisInitialized(_this), "_getIsControlled", function () {
      return 'value' in _this.props && 'onChange' in _this.props;
    });

    _defineProperty(_assertThisInitialized(_this), "_getFilteredOptions", function () {
      var _this$props = _this.props,
          options = _this$props.options,
          predicate = _this$props.predicate;

      var searchText = _this._currentValue();

      if (!searchText || !searchText.length) {
        return options;
      }

      var filterFn = predicate || _this._stringFilter;
      return options.filter(filterFn);
    });

    _defineProperty(_assertThisInitialized(_this), "_stringFilter", function (option) {
      var searchText = _this._currentValue();

      return StringUtils.includesCaseInsensitive(option.value, searchText.trim());
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (e) {
      e.persist();

      _this.setState({
        inputValue: e.target.value
      }, function () {
        _this._onChangeHandler(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onClear", function (event) {
      var expandable = _this.props.expandable;
      var collapsed = _this.state.collapsed;
      var stateChanges = {};

      if (!_this._getIsControlled()) {
        stateChanges.inputValue = '';
      }

      if (expandable && !collapsed) {
        stateChanges.collapsed = true;

        _this.searchInput.input.blur();
      }

      if (!isEmpty(stateChanges)) {
        // call onClear only *after* updating the search value
        _this.setState(stateChanges, function () {
          _this._onClearHandler(event);
        });
      } else {
        _this._onClearHandler(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClearHandler", function (event) {
      var onClear = _this.props.onClear;
      if (onClear) onClear(event);

      _this.searchInput.hideOptions();
    });

    _defineProperty(_assertThisInitialized(_this), "_currentValue", function () {
      return _this.state.inputValue;
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (event) {
      var onFocus = _this.props.onFocus;

      if (_this.state.collapsed && _this.props.expandable) {
        _this.setState({
          collapsed: false
        });
      }

      onFocus && onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      if (!_this.state.collapsed && _this.props.expandable) {
        var value = _this._currentValue();

        if (value === '') {
          _this.setState({
            collapsed: true
          });
        }
      }

      onBlur && onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "_onWrapperClick", function () {
      if (_this.props.expandable && _this.state.collapsed) {
        _this.searchInput.input.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onWrapperMouseDown", function (e) {
      // We need to capture mouse down and prevent it's event if the input
      // is already open
      if (_this.props.expandable && !_this.state.collapsed) {
        var value = _this._currentValue();

        if (value === '') {
          e.preventDefault();
        }
      }
    });

    var initialValue = _this._getIsControlled() ? props.value : props.defaultValue || '';
    _this._onChangeHandler = _this._makeOnChange();
    _this.state = {
      inputValue: initialValue,
      collapsed: props.expandable && !initialValue && !props.autoFocus
    };
    return _this;
  }

  _createClass(Search, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({
          inputValue: this.props.value
        });
      }

      if (prevProps.debounceMs !== this.props.debounceMs) {
        this._onChangeHandler = this._makeOnChange();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          defaultValue = _this$props2.defaultValue,
          dataHook = _this$props2.dataHook,
          expandWidth = _this$props2.expandWidth,
          restProps = _objectWithoutProperties(_this$props2, ["defaultValue", "dataHook", "expandWidth"]);

      var expandable = restProps.expandable,
          size = restProps.size;
      var _this$state = this.state,
          collapsed = _this$state.collapsed,
          inputValue = _this$state.inputValue;
      var wrapperClasses = classNames((_classNames = {}, _defineProperty(_classNames, styles.expandableStyles, expandable), _defineProperty(_classNames, styles.collapsed, collapsed && expandable), _defineProperty(_classNames, styles.expanded, !collapsed && expandable), _defineProperty(_classNames, styles.small, size === 'small'), _classNames));
      var contentStyle = expandable && !collapsed ? {
        width: expandWidth
      } : undefined;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: wrapperClasses,
        onClick: this._onWrapperClick,
        onMouseDown: this._onWrapperMouseDown
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.content,
        style: contentStyle
      }, /*#__PURE__*/React.createElement(InputWithOptions, _extends({}, restProps, {
        value: inputValue,
        ref: function ref(r) {
          return _this2.searchInput = r;
        },
        roundInput: true,
        prefix: /*#__PURE__*/React.createElement(Input.IconAffix, null, /*#__PURE__*/React.createElement(SearchIcon, null)),
        dataHook: "search-inputwithoptions",
        menuArrow: false,
        closeOnSelect: true,
        options: this._getFilteredOptions(),
        onClear: restProps.clearButton ? this._onClear : undefined,
        onChange: this._onChange,
        onFocus: this._onFocus,
        onBlur: this._onBlur,
        highlight: true
      }))));
    }
  }]);

  return Search;
}(Component);

_defineProperty(Search, "displayName", 'Search');

_defineProperty(Search, "propTypes", _objectSpread(_objectSpread({}, InputWithOptions.propTypes), {}, {
  /** Will display the search icon only until clicked */
  expandable: PropTypes.bool,

  /** Width used for expanded state */
  expandWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Custom function for filtering options */
  predicate: PropTypes.func,

  /** onChange debounce in milliseconds */
  debounceMs: PropTypes.number
}));

_defineProperty(Search, "defaultProps", _objectSpread(_objectSpread({}, InputWithOptions.defaultProps), {}, {
  clearButton: true,
  placeholder: 'Search',
  expandable: false,
  expandWidth: '100%',
  debounceMs: 0,
  onChange: function onChange() {}
}));

export default Search;